import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhTWiosApp from './locales/zh-TW/iosApp.json';
import zhCNiosApp from './locales/zh-CN/iosApp.json';
import enIosApp from './locales/en/iosApp.json';
import jaIosApp from './locales/ja/iosApp.json';
import koIosApp from './locales/ko/iosApp.json';

import zhTWpayment from './locales/zh-TW/payment.json';
import zhCNpayment from './locales/zh-CN/payment.json';
import enPayment from './locales/en/payment.json';
import jaPayment from './locales/ja/payment.json';
import koPayment from './locales/ko/payment.json';

const resources = {
  'zh-TW': { iosApp: zhTWiosApp, payment: zhTWpayment },
  'zh-CN': { iosApp: zhCNiosApp, payment: zhCNpayment },
  en:      { iosApp: enIosApp,   payment: enPayment },
  ja:      { iosApp: jaIosApp,   payment: jaPayment },
  ko:      { iosApp: koIosApp,   payment: koPayment },
};

const supportedLangs = ['zh-TW', 'zh-CN', 'en', 'ja', 'ko'];
const detected = navigator.language || '';
const defaultLang =
  supportedLangs.find((l) => detected === l) ??
  supportedLangs.find((l) => detected.startsWith(l)) ??
  (detected.startsWith('zh') ? 'zh-TW' : null) ??
  supportedLangs.find((l) => detected.startsWith(l.split('-')[0])) ??
  'zh-TW';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLang,
    fallbackLng: 'zh-TW',
    ns: ['iosApp', 'payment'],
    interpolation: { escapeValue: false },
  });

export default i18n;
